var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4421_5762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.52 5.56732V9.91578C31.39 12.7489 33.7715 18.4151 33.7715 25.3989C33.7715 35.9736 29.4385 41.541 21.9631 41.541C21.7977 41.541 21.6985 41.541 21.5331 41.541C21.3677 41.541 21.2685 41.541 21.1031 41.541C13.5615 41.508 9.26154 35.9736 9.26154 25.3989C9.26154 18.4151 11.5438 12.7489 15.5131 9.91578V5.56732C6.11923 7.90627 0 15.5161 0 25.0036C0 37.6866 8.13692 45 21.4338 45C21.4338 45 21.4338 45 21.5 45C21.5662 45 21.5 45 21.5662 45C34.8631 45 43 37.6866 43 25.0036C42.9338 15.5161 36.8808 7.90627 27.52 5.56732Z",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6631 0L18.1592 23.06H24.7746L25.2708 0H17.6631Z",
    fill: "#CE1126"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4421_5762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.23426af735581f6d5c14a21312ff9b79.svg";
export { ForwardRef as ReactComponent };